import { render, staticRenderFns } from "./packView.vue?vue&type=template&id=c65582f8&"
import script from "./packView.vue?vue&type=script&lang=js&"
export * from "./packView.vue?vue&type=script&lang=js&"
import style0 from "./packView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c65582f8')) {
      api.createRecord('c65582f8', component.options)
    } else {
      api.reload('c65582f8', component.options)
    }
    module.hot.accept("./packView.vue?vue&type=template&id=c65582f8&", function () {
      api.rerender('c65582f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/components/packView.vue"
export default component.exports